// Sculpture product form. Prices always come from Shopify variants (data-price
// is rendered server-side from variant.price); the client only adds them up for
// display. Shopify recalculates everything at checkout.

const form = document.querySelector('[data-unmi-product-form]');
if (form) init(form);

function moneyFormatter(sample) {
  // sample is "{{ 100 | money }}", e.g. "A$1.00"; keep the store's own format.
  const [pre, post] = (sample || 'A$1.00').split('1.00');
  return (cents) => `${pre}${(cents / 100).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}${post || ''}`;
}

function groupId() {
  const a = new Uint8Array(6);
  crypto.getRandomValues(a);
  return `g-${Array.from(a, (b) => b.toString(16).padStart(2, '0')).join('')}`;
}

function init(form) {
  const money = moneyFormatter(form.dataset.moneySample);
  const total = form.querySelector('[data-total]');
  const submit = form.querySelector('[data-product-submit]');
  const label = form.querySelector('[data-submit-label]');
  const status = form.querySelector('[data-product-status]');
  const canBuy = form.dataset.canBuy === 'true';
  const strings = JSON.parse(form.dataset.strings || '{}');

  const selectedRadio = () => form.querySelector('input[name="id"]:checked');
  const keepsakes = () => [...form.querySelectorAll('input[name="keepsake"]:checked')];

  function updateTotal() {
    if (!total) return;
    const base = Number(selectedRadio()?.dataset.price || 0);
    const nb = form.querySelector('[data-name-base-toggle]:checked');
    const extra = keepsakes().reduce((s, k) => s + Number(k.dataset.price || 0), 0) + Number(nb?.dataset.price || 0);
    total.textContent = money(base + extra);
  }

  // the base with their name: the name field shows once it's ticked
  const nbToggle = form.querySelector('[data-name-base-toggle]');
  const nbField = form.querySelector('[data-name-base-field]');
  const nbText = form.querySelector('[data-name-base-text]');
  if (nbToggle && nbField) nbToggle.addEventListener('change', () => { nbField.hidden = !nbToggle.checked; if (nbToggle.checked) nbText.focus(); });

  form.addEventListener('change', (e) => {
    if (e.target.name === 'id') {
      const url = new URL(location.href);
      url.searchParams.set('variant', e.target.value);
      history.replaceState(null, '', url);
      document.dispatchEvent(new CustomEvent('unmi:variant-change', { detail: { id: Number(e.target.value), height: Number(e.target.dataset.height) } }));
    }
    updateTotal();
  });

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (!canBuy || submit.disabled) return;
    submit.disabled = true;
    submit.setAttribute('aria-busy', 'true');
    label.textContent = strings.adding || 'Adding';
    status.textContent = '';
    // The pet's name goes on every line as "Pet name"; the order system reads it for every email and page.
    const petInput = form.querySelector('[data-pet-name]');
    const petName = petInput ? petInput.value.trim() : '';
    if (petInput && !petName) {
      status.innerHTML = `<span class="field-error">Add their name so we can make everything personal to them.</span>`;
      submit.disabled = false; submit.removeAttribute('aria-busy'); label.textContent = strings.add || 'Add to cart';
      petInput.focus(); return;
    }
    const pet = petName ? { 'Pet name': petName } : {};
    const group = groupId();
    const items = [{ id: Number(selectedRadio().value), quantity: 1, properties: { _group: group, ...pet } }];
    for (const k of keepsakes()) items.push({ id: Number(k.value), quantity: 1, properties: { _group: group, _addon: 'keepsake', ...pet } });
    if (nbToggle?.checked) {
      const name = nbText.value.trim();
      if (!name) {
        status.innerHTML = `<span class="field-error">Add their name for the base, or untick it.</span>`;
        submit.disabled = false; submit.removeAttribute('aria-busy'); label.textContent = strings.add || 'Add to cart';
        nbText.focus(); return;
      }
      items.push({ id: Number(nbToggle.value), quantity: 1, properties: { _group: group, _addon: 'name-base', Name: name, ...pet } });
    }
    try {
      const gift = form.querySelector('[data-gift]');
      if (gift?.checked) {
        // Only a yes/no flag goes on the cart. Recipient details are collected
        // privately after checkout, never in cart or checkout attributes.
        await post('/cart/update.js', { attributes: { Gift: 'Yes' } });
      }
      await post('/cart/add.js', { items });
      const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      document.querySelectorAll('[data-cart-count]').forEach((n) => { n.textContent = cart.item_count; n.closest('.cart-link')?.toggleAttribute('data-empty', !cart.item_count); });
      status.innerHTML = `<span class="product-form__added"><strong>${strings.added || 'Added to your cart'}</strong> <a class="link" href="/cart">${strings.view_cart || 'Review your cart'}</a></span>`;
      label.textContent = strings.add || 'Add to cart';
    } catch (err) {
      status.innerHTML = `<span class="field-error">${err.message || strings.error}</span>`;
      label.textContent = strings.add || 'Add to cart';
    } finally {
      submit.disabled = false;
      submit.removeAttribute('aria-busy');
    }
  });

  async function post(url, body) {
    const r = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    if (!r.ok) {
      const j = await r.json().catch(() => ({}));
      throw new Error(j.description || strings.error || 'Something went wrong.');
    }
    return r.json();
  }

  // arriving from the collection with ?keepsake=<handle>: open the keepsakes and tick that one
  const wanted = new URL(location.href).searchParams.get('keepsake');
  const pick = wanted && [...form.querySelectorAll('input[name="keepsake"]')].find((k) => k.dataset.handle === wanted);
  if (pick) {
    pick.checked = true;
    const box = pick.closest('details');
    if (box) box.open = true;
  }

  updateTotal();
  if (document.querySelector('[data-viewer]')) import(new URL('viewer.js', import.meta.url).href);
}
